import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { END_LOADING, ERROR, FILTER, START_LOADING, UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';
import { resourcesService } from '@/main/services';

import { DMS_MODULE, NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Statuses: [],
		PlatbaPzn: [],
	},
	filter: {
		PrijemkaPfx: null as null | string,
		PrijemkaNr: null as null | number,
		DodListNr: null as null | string,
		DodFaktNr: null as null | string,
		SupplierName: null as null | string,
		NdprijemPzn: null as null | number,
		PaymentMode: null as null | number,
		StatusId: null as null | number,
		PROrderId: null as number | null,
		PRInvoiceNr: null as number | null,
		PRInvoicePfx: null as null | string,
		DodavatelId: null as null | number,
		FromDate: null as null | string,
		ToDate: null as null | string,
	},
	tableSetting: {},
	localState: {
		StatusPrijemky: null,
	},
	rowDetail: null,
	extraGetters: {},
	extraActions: {
		async [FILTER]({ commit, dispatch }) {
			try {
				commit(START_LOADING);
				const [resp] = await Promise.all(
					[apiProvider.filter()],
				);
				commit(UPDATE_BASIC_FILTER, resp!.data);
				return resp;
			} catch (err) {
				dispatch(ERROR, { DMS_MODULE, err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
	},
	extraMutations: {
		[listMutations.ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.DodavatelId = data.value;
			state.filter.SupplierName = data.text;
		},
		[listMutations.ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER](state, { data }) {
			state.filter.PROrderId = data.value;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
